import { Component, OnInit } from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';

@Component({
  selector: 'app-dx-checkbox-cell-editor',
  templateUrl: './dx-checkbox-cell-editor.component.html',
  styleUrls: ['./dx-checkbox-cell-editor.component.css']
})
export class DxCheckboxCellEditorComponent implements ICellEditorAngularComp {

  constructor() { }

  /** Значение чекбокса */
  public cbValue: boolean;

  private _params: ICellRendererParams;

  onClick(): void {
    this.cbValue = !this.cbValue;
  }

  agInit(params: any): void {
    this._params = params;
    // если вошли по ентеру, то переключаем состояние
    if (params.keyPress === 13) {
      this.cbValue =  !params.value;
    } else {
      this.cbValue =  params.value;
    }
  }

  getValue(): any {
    return this.cbValue;
  }

}
